import React, { Component } from 'react';
import { connect } from 'react-redux'
import Aux from "../../../hoc/_Aux";
import queryString from 'query-string';
import { SSO_PORTAL_AUTH_VERIFY } from '../../../store/actions/auth';
import Auth from '../../../models/Auth';

import { GET_PROGRAM_DATA, SET_PORTAL_ERROR } from '../../../store/actions/dashboardAction';
import { GET_PORTAL_LOGO, SET_PORTAL_REDUCER_ERROR } from '../../../store/actions/portal';
import { portalLogoUrl } from '../../../helper/utils';
import withRouter from '../../../App/components/withRouter';
import { toast } from 'react-toastify';
/* Redux State Props */
const mapStateToProps = state => {
    return {
        forgotPswdError: state.auth.forgotPswdError,
        selectedPortalLogo: state.portal.selectedPortalLogo,
        isUserAuthenticated: state.auth.isUserAuthenticated,

        portalLogoName: state.portal.portalLogoName,
        programError: state.allRequest.programError,
        portalError: state.portal.portalError,
        programData: state.allRequest.programData
    }
}

/*  Redux action Props */
const mapDispatchToProps = {
    SSO_PORTAL_AUTH_VERIFY: (payload) => SSO_PORTAL_AUTH_VERIFY(payload),
    GET_PORTAL_LOGO: (payload) => GET_PORTAL_LOGO(payload),
    GET_PROGRAM_DATA: (payload) => GET_PROGRAM_DATA(payload),
    SET_PORTAL_ERROR: (message) => SET_PORTAL_ERROR(message),
    SET_PORTAL_REDUCER_ERROR: (message) => SET_PORTAL_REDUCER_ERROR(message)
}


class SamlRedirect extends Component {
    constructor(props) {
        super(props)
        const queryParams = queryString.parse(this.props.location.search)
        const pathParams = this.props.params
        console.log('pathParams', pathParams)
        console.log('queryParams', queryParams)
        const pId = parseInt((pathParams.portalId) || '0')
        const cId = parseInt((pathParams.clientId) || '0')
        this.state = {
            portalId: pId,
            clientId: cId,
            code: queryParams.code,
            queryParams: queryParams,
        }
    }

    componentDidMount = async () => {
        const { portalId, clientId, code } = this.state;
        // if (!(portalId && clientId && code)) {
        //     toast.error('Something went wrong with the redirect url. Please contact Admin for more information')
        // }
        await this.props.SSO_PORTAL_AUTH_VERIFY({ portalId, clientId, code })

        // List User Portal Info
        if (!this.props.programData || !Object.keys(this.props.programData).length || ((this.props.programData["id"] !== portalId))) {
            await this.props.GET_PROGRAM_DATA({ portalId, clientId });
            if (this.props.programError) {
                console.log(`portal Error Occurred :`, this.props.programError)
                this.props.SET_PORTAL_ERROR(null);
                return;
            }
        }

        // GET_PORTAL_LOGO()

        // if (this.props.programData && this.props.programData.name && this.props.programData.name !== 'undefined') {
        //     document.title = this.props.programData.name + ' | Client Portal';
        // }

        // Main Users Portal Info
        if (Auth.token && !Auth.isTokenExpired) {
            this.props.navigate(`/dashboard?pId=${portalId}&cId=${clientId}`)
        }
    }


    fetchAllRedirectData = () => {
        console.log(`All Frontend Portal`, this.props, this.props.match);
    }

    render() {
        return (
            <Aux>
                
                <div className="auth-wrapper">
                    <img src={portalLogoUrl()} alt="Logo" className="login-bg" style={{ fontWeight: "bold" }} />
                    Loading...
                </div>
            </Aux>
        )
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SamlRedirect))

